// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tenant-administrator-account-edit-server-connection-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.45);
}
.tenant-administrator-account-edit-server-connection-container{
    margin-bottom: 16vh;
    width: 32vw;
    border-radius: 5px;
    background-color: white;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-account-edit-server-connection-header{
    padding: 12px 20px;
    display: flex;
    justify-content: space-between;
    border-radius: 5px 5px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.tenant-administrator-account-edit-server-connection-header h1{
    margin: 0px;
    color: white;
    font-size: 20px;
    font-weight: 600;
}
.tenant-administrator-account-edit-server-connection-header .buttons-container{
    display: flex;
    align-items: center;
}
.tenant-administrator-account-edit-server-connection-header .buttons-container .help-button{
    padding: 0;
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 50%;
    font-size: 15px;
    cursor: pointer;
    margin-left: 10px;
    color: rgba(155, 30, 30, 0.952);
}
.tenant-administrator-account-edit-server-connection-header .buttons-container .close-button{
    border: none;
    color: white;
    padding: 0;
    width: 30px;
    height: 30px;
    font-size: 18px;
    cursor: pointer;
    border-radius: 50%;
    margin-left: 10px;
    background-color: transparent;
    transition: background-color 0.25s ease;
}
.tenant-administrator-account-edit-server-connection-header .buttons-container .close-button:hover{
    background-color: rgba(102, 19, 19, 0.952);
}
.tenant-administrator-account-edit-server-connection-body{
    padding: 5px 16px;
}
.tenant-administrator-account-edit-server-connection-entry-container{
    margin: 20px 0px;
    padding: 4px 10px;
    box-sizing: border-box;
    background-color: rgba(222, 229, 233, 0.6);
    border-bottom: 1px solid rgb(128, 128, 128);
}
.tenant-administrator-account-edit-server-connection-entry-container:focus-within{
    border-bottom: 1px solid rgba(155, 30, 30, 0.952);
}
.tenant-administrator-account-edit-server-connection-entry-container p{
    margin: 0px;
    font-size: 12px;
    color: rgb(88, 88, 88);
}
.tenant-administrator-account-edit-server-connection-entry-container span{
    color: red;
}
.tenant-administrator-account-edit-server-connection-entry-container input{
    width: 100%;
    outline: none;
    border: none;
    background-color: transparent;
}
.tenant-administrator-account-edit-server-connection-default-selection-container{
    display: inline-flex;
    align-items: center;
}
.tenant-administrator-account-edit-server-connection-default-selection-container p{
    margin: 0px;
    font-size: 14px;
    color: rgb(66, 66, 66);
    cursor: pointer;
}
.tenant-administrator-account-edit-server-connection-default-selection-container input{
    margin-top: 5px;
    margin-left: 10px;
    cursor: pointer;
}
.tenant-administrator-account-edit-server-connection-control-buttons-container{
    padding: 16px;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    box-shadow: 0px 0px 8px rgba(199, 199, 199, 0.15);
}
.tenant-administrator-account-edit-server-connection-control-buttons-container button{
    font-weight: 600;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}
.tenant-administrator-account-edit-server-connection-control-buttons-container .cancel-button{
    padding: 10px 20px;
    color: rgba(155, 30, 30, 0.952);
    background-color: rgb(240, 240, 240);
}
.tenant-administrator-account-edit-server-connection-control-buttons-container .add-button{
    padding: 10px 25px;
    opacity: 0.7;
    font-weight: 500;
    cursor: not-allowed;
    color: rgb(196, 196, 196);
    background-color: rgb(240, 240, 240);
}
.tenant-administrator-account-edit-server-connection-control-buttons-container .add-button.active{
    opacity: 1;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
}

.tenant-administrator-account-updating-server-connection-container{
    border-radius: 4px;
    padding: 18px 56px;
    padding-top: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: white;
}
.tenant-administrator-account-updating-server-connection-container div{
    width: 32px;
    height: 32px;
    border: 2px solid brown;
    border-top-color: transparent;
    border-radius: 50%;
    animation: tenant-administrator-account-updating-server-connection-container-spin 0.8s linear infinite;
}
@keyframes tenant-administrator-account-updating-server-connection-container-spin{
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-account-updating-server-connection-container p{
    font-size: 14px;
    color: rgb(92, 92, 92);
}


.tenant-administrator-account-updated-server-connection-container{
    border-radius: 4px;
    padding: 6px 16px;
    padding-right: 20px;
    background-color: white;
}
.tenant-administrator-account-updated-server-connection-container p{
    margin: 0px;
    margin-top: 12px;
    margin-bottom: 8px;
    font-size: 14px;
    color: rgb(75, 75, 75);
}
.tenant-administrator-account-updated-server-connection-container span{
    font-size: 16px;
    color: green;
    margin-right: 4px;
}
.tenant-administrator-account-updated-server-connection-container .control-buttons-container{
    text-align: right;
    padding: 8px 0px;
}
.tenant-administrator-account-updated-server-connection-container .control-buttons-container button{
    border: none;
    margin-left: 24px;
    padding: 8px 25px;
    border-radius: 4px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    font-family: Roboto, sans-serif;
    color: rgb(255, 255, 255);
    background-color: rgba(145, 40, 40, 0.952);
    transition: background-color 0.25s ease;
}
.tenant-administrator-account-updated-server-connection-container .control-buttons-container button:hover{
    background-color: rgba(180, 52, 52, 0.952);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Accounts/EditServerConnection.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;AACzC;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,4DAA4D;AAChE;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,8BAA8B;IAC9B,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,+BAA+B;AACnC;AACA;IACI,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B,uCAAuC;AAC3C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,0CAA0C;IAC1C,2CAA2C;AAC/C;AACA;IACI,iDAAiD;AACrD;AACA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,iDAAiD;AACrD;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,oCAAoC;AACxC;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;AACxC;AACA;IACI,UAAU;IACV,YAAY;IACZ,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,sGAAsG;AAC1G;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;;;AAGA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,+BAA+B;IAC/B,yBAAyB;IACzB,0CAA0C;IAC1C,uCAAuC;AAC3C;AACA;IACI,0CAA0C;AAC9C","sourcesContent":[".tenant-administrator-account-edit-server-connection-parent-container{\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    width: 100vw;\n    z-index: 10;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(0, 0, 0, 0.45);\n}\n.tenant-administrator-account-edit-server-connection-container{\n    margin-bottom: 16vh;\n    width: 32vw;\n    border-radius: 5px;\n    background-color: white;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.tenant-administrator-account-edit-server-connection-header{\n    padding: 12px 20px;\n    display: flex;\n    justify-content: space-between;\n    border-radius: 5px 5px 0px 0px;\n    background-color: rgba(155, 30, 30, 0.952);\n}\n.tenant-administrator-account-edit-server-connection-header h1{\n    margin: 0px;\n    color: white;\n    font-size: 20px;\n    font-weight: 600;\n}\n.tenant-administrator-account-edit-server-connection-header .buttons-container{\n    display: flex;\n    align-items: center;\n}\n.tenant-administrator-account-edit-server-connection-header .buttons-container .help-button{\n    padding: 0;\n    width: 24px;\n    height: 24px;\n    border: none;\n    border-radius: 50%;\n    font-size: 15px;\n    cursor: pointer;\n    margin-left: 10px;\n    color: rgba(155, 30, 30, 0.952);\n}\n.tenant-administrator-account-edit-server-connection-header .buttons-container .close-button{\n    border: none;\n    color: white;\n    padding: 0;\n    width: 30px;\n    height: 30px;\n    font-size: 18px;\n    cursor: pointer;\n    border-radius: 50%;\n    margin-left: 10px;\n    background-color: transparent;\n    transition: background-color 0.25s ease;\n}\n.tenant-administrator-account-edit-server-connection-header .buttons-container .close-button:hover{\n    background-color: rgba(102, 19, 19, 0.952);\n}\n.tenant-administrator-account-edit-server-connection-body{\n    padding: 5px 16px;\n}\n.tenant-administrator-account-edit-server-connection-entry-container{\n    margin: 20px 0px;\n    padding: 4px 10px;\n    box-sizing: border-box;\n    background-color: rgba(222, 229, 233, 0.6);\n    border-bottom: 1px solid rgb(128, 128, 128);\n}\n.tenant-administrator-account-edit-server-connection-entry-container:focus-within{\n    border-bottom: 1px solid rgba(155, 30, 30, 0.952);\n}\n.tenant-administrator-account-edit-server-connection-entry-container p{\n    margin: 0px;\n    font-size: 12px;\n    color: rgb(88, 88, 88);\n}\n.tenant-administrator-account-edit-server-connection-entry-container span{\n    color: red;\n}\n.tenant-administrator-account-edit-server-connection-entry-container input{\n    width: 100%;\n    outline: none;\n    border: none;\n    background-color: transparent;\n}\n.tenant-administrator-account-edit-server-connection-default-selection-container{\n    display: inline-flex;\n    align-items: center;\n}\n.tenant-administrator-account-edit-server-connection-default-selection-container p{\n    margin: 0px;\n    font-size: 14px;\n    color: rgb(66, 66, 66);\n    cursor: pointer;\n}\n.tenant-administrator-account-edit-server-connection-default-selection-container input{\n    margin-top: 5px;\n    margin-left: 10px;\n    cursor: pointer;\n}\n.tenant-administrator-account-edit-server-connection-control-buttons-container{\n    padding: 16px;\n    padding-top: 20px;\n    display: flex;\n    justify-content: space-between;\n    box-shadow: 0px 0px 8px rgba(199, 199, 199, 0.15);\n}\n.tenant-administrator-account-edit-server-connection-control-buttons-container button{\n    font-weight: 600;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n.tenant-administrator-account-edit-server-connection-control-buttons-container .cancel-button{\n    padding: 10px 20px;\n    color: rgba(155, 30, 30, 0.952);\n    background-color: rgb(240, 240, 240);\n}\n.tenant-administrator-account-edit-server-connection-control-buttons-container .add-button{\n    padding: 10px 25px;\n    opacity: 0.7;\n    font-weight: 500;\n    cursor: not-allowed;\n    color: rgb(196, 196, 196);\n    background-color: rgb(240, 240, 240);\n}\n.tenant-administrator-account-edit-server-connection-control-buttons-container .add-button.active{\n    opacity: 1;\n    color: white;\n    cursor: pointer;\n    background-color: rgba(155, 30, 30, 0.952);\n}\n\n.tenant-administrator-account-updating-server-connection-container{\n    border-radius: 4px;\n    padding: 18px 56px;\n    padding-top: 32px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background-color: white;\n}\n.tenant-administrator-account-updating-server-connection-container div{\n    width: 32px;\n    height: 32px;\n    border: 2px solid brown;\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: tenant-administrator-account-updating-server-connection-container-spin 0.8s linear infinite;\n}\n@keyframes tenant-administrator-account-updating-server-connection-container-spin{\n    from{\n        transform: rotate(0deg);\n    }\n    to{\n        transform: rotate(360deg);\n    }\n}\n.tenant-administrator-account-updating-server-connection-container p{\n    font-size: 14px;\n    color: rgb(92, 92, 92);\n}\n\n\n.tenant-administrator-account-updated-server-connection-container{\n    border-radius: 4px;\n    padding: 6px 16px;\n    padding-right: 20px;\n    background-color: white;\n}\n.tenant-administrator-account-updated-server-connection-container p{\n    margin: 0px;\n    margin-top: 12px;\n    margin-bottom: 8px;\n    font-size: 14px;\n    color: rgb(75, 75, 75);\n}\n.tenant-administrator-account-updated-server-connection-container span{\n    font-size: 16px;\n    color: green;\n    margin-right: 4px;\n}\n.tenant-administrator-account-updated-server-connection-container .control-buttons-container{\n    text-align: right;\n    padding: 8px 0px;\n}\n.tenant-administrator-account-updated-server-connection-container .control-buttons-container button{\n    border: none;\n    margin-left: 24px;\n    padding: 8px 25px;\n    border-radius: 4px;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n    font-family: Roboto, sans-serif;\n    color: rgb(255, 255, 255);\n    background-color: rgba(145, 40, 40, 0.952);\n    transition: background-color 0.25s ease;\n}\n.tenant-administrator-account-updated-server-connection-container .control-buttons-container button:hover{\n    background-color: rgba(180, 52, 52, 0.952);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
